import {HorizontalStandardPanel} from "@/scenes.ui/horizontal-standard-panel";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import Scene = Phaser.Scene;
import Text = Phaser.GameObjects.Text;
import InputText from "phaser3-rex-plugins/plugins/gameobjects/dom/inputtext/InputText";
import {Tr} from "@/i18n/i18n";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class InputTextPanel extends HorizontalStandardPanel {

    private readonly MIN_NAME_LENGTH: number = 0;
    private readonly MAX_NAME_LENGTH: number = 300;

    private error!: Text;

    constructor(scene: Scene, canvas: HTMLCanvasElement, header:string, desc:string,  inputPlaceholder:string, action:string,
                defaultText:string, createCallback: (clanName: string) => void, max_length?:number) {
        super(scene, canvas, header);

        let titleText = TextUtils.addTextAdvanced(this.scene,
            desc, 0, -110, '#ffd465', 20,
            'normal', 450, 'center', 1, Fonts.MYRIADPRO_REGULAR);

		let inputField = SpriteUtils.addImage(scene, 0, 0, Keys.UI_NOTIF_PANEL, undefined, 400/517, 110/121);

        this.error = TextUtils.addTextAdvanced(this.scene,
            "", 0, inputField.getBottomCenter().y! / CU.S + 20, '#791427', 14,
            'normal', 450, 'center', 1, Fonts.MYRIADPRO_BOLD).setVisible(false);

        let w = 350 * CU.CSS_S;
        let h = 66 * CU.CSS_S;

        let inputText = new InputText(scene, -CU.CANVAS_WIDTH / 2 + CU.CSS_WIDTH / 2 + 2, -CU.CANVAS_HEIGHT / 2 + CU.CSS_HEIGHT / 2 + 10 * CU.S,
            w, h, {
                type: 'textarea',
                id: undefined,
                text: defaultText,
                maxLength: max_length || this.MAX_NAME_LENGTH,
                minLength: this.MIN_NAME_LENGTH,
                placeholder: inputPlaceholder,
                tooltip: undefined,
                readOnly: false,
                spellCheck: false,
                autoComplete: 'off',

                // Style properties
                align: "left",
                paddingLeft: undefined,
                paddingRight: undefined,
                paddingTop: undefined,
                paddingBottom: undefined,
                fontFamily: undefined,
                fontSize: undefined,
                color: '#ffffff',
                border: 0,
                backgroundColor: 'transparent',
                borderColor: 'transparent',
                outline: 'none',
                //direction: 'ltr',

                selectAll: false
            }).setOrigin(0.5, 0.5);

        this.addButton(action, Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {

            if (inputText.text.length > this.MAX_NAME_LENGTH) {
                this.showError(Tr('text.is.too.long'));
                return;
            }

            if (createCallback != null) {
                createCallback(inputText.text);
            }
        }, true);

        this.add([titleText, inputField, inputText, this.error]);
    }

    public showError(text: string) {
        this.error.setText(text);
        this.error.setVisible(true);
    }

    public closePanel() {
        this.onClose();
        this.close();
    }


}
